import React,{useState,useEffect} from 'react';
import { OpenAIApi } from 'openai';
import { Configuration } from 'openai';
import getAiResponse from '../actions/openAi';
import openaiimg from '../assets/img/13.jpeg'
import axios from 'axios'


import Conversation from '../models/ConversationSchema'
// const responses = { response: '', date:Date.now()}

let currentDay = new Date();
 let month = currentDay.getMonth() + 1; 
 let year = currentDay.getFullYear().toString().slice(-2); 
 let formattedDate = month + "/" + year; 
const responses = []
const prompts = []
const responseData = []
const REACT_APP_OPENAI_KEY = process.env.REACT_APP_OPENAI_KEY
const saveConversation = async (prompt, aiResponse) => {
      const conversation = new Conversation({
        prompt,
        aiResponse
      });
    
      try {
        const savedConversation = await conversation.save();
        console.log("Awaiting saved conversation? I dont fuckin know yet bud.")
      } catch (err) {
        console.log(err)
      }
    };



function OpenAiImage(){
  const [prompt, setPrompt] = useState("");
 const [result, setResult]= useState("")
 const [isLoading, setIsLoading] = useState(false);

const [currentDate, setCurrentDate] = useState('')

const configuration = new Configuration({
  apiKey: REACT_APP_OPENAI_KEY,
})

const openai = new OpenAIApi(configuration);

function getCurrentDateTime() { let currentDateTime = new Date(); console.log("current: ",currentDateTime) 
return currentDateTime; }


function getDateTime() { let now = new Date(); let date = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate(); let time = now.getHours() + ':' + now.getMinutes() + ':' + now.getSeconds(); let dateTime = date + ' ' + time; 
console.log("DATTTTEEE",dateTime)
return dateTime; }






// useEffect(() => { const fetchData = async () => { const response = await fetch('/api/data'); const { responses, prompts } = await response.json(); 
// // send the response back to mongodb
//  axios.put('/api/data', { responses, prompts }) .then(res => console.log(res)) .catch(err => console.log(err)); }
//   fetchData(); }, []);




const saveFile = (variable1, variable2) => {
    let prompt = document.querySelector('#prompt').innerHTML
  let response = document.querySelector('#response').innerHTML
   const saveData = { prompt, response };
    const blob = new Blob([JSON.stringify(saveData)], { type: 'application/json'}); 
    const url = window.URL.createObjectURL(blob);
     const a = document.createElement('a');
      a.href = url;
      a.download = 'variables.json'; 
     a.click(); window.URL.revokeObjectURL(url); }




  const generateStream = async() =>{

    setIsLoading(true)
    getDateTime()

prompts.push(prompt)
console.log(prompts,"PPPRROMPTS")

    setCurrentDate(getDateTime())
    getCurrentDateTime()
try{    
    console.log('generateStream was called, and is now in the try block') 
   const res =  await openai.createCompletion({
          best_of:1,
          // echo:true,
          frequency_penalty:0,
          logprobs:0,
          max_tokens:2560,
          presence_penalty:0,
          prompt:prompt,
          model:"text-davinci-003",
          stream:true,
          temperature:0.78,
          top_p:1
      })

      const responseText = res.data.split('data:')
      .filter(text => text.includes('text'))
      .map(text => {
        const { text: responseText } = JSON.parse(text).choices[0];
        const aiResponse = responseText.replace(`/^(?!.*${prompt}).*$/, ''`)
        return aiResponse
      })
      .join('');
responseData.push(res)
responses.push(responseText)
console.log(responses,"REEESSPONSSES")
console.log(responseData, "ResponseData")
// Log the response text
console.log('responsetext',responseText, res); 
setResult(responseText)
setIsLoading(false)
} catch(error){
  console.log("FROM \'generateStream\', in the catch block, THE ERROR IS RELATED TO: ",error)
}
    console.log('You did it bud, carry on')
    }
  

  return (
     <div className="App">


   
      <div className='openai-header'>
        <h2 className='openai-h2'>Start the stream</h2>
 <img className='banner' src={openaiimg} alt='AI Enthusiast' />
 </div>

        <textarea
          id="userInputField"
          className='ff'
          placeholder="Start a stream with GPT "
          onChange={(e) => setPrompt(e.target.value)}
          rows="5"
          cols="100"
        />
        <button className="generate-image-btn btn" onClick={generateStream}>
          
        {isLoading ? (
        <span>
          <i className="fa fa-spinner fa-spin" /> Loading
        </span>
      ) : (
        "Stream"
      )}
          
          
          </button>

         




<div id="returnedFromAi" className='returnedFromAi'>


 {result ?


 <div className='result-box'>

   <label className='btn footer'> <h2 className='fit'>User</h2><br/> <h3 className='date'>{currentDate}</h3><p id="prompt" className='prompt-text no-over'>
       {prompt && !prompt.err? prompt : <></>}
   </p>  </label>


   <label className='btn footer'><h2 className='fit'>AI</h2><br/><h3 className='date'>{getDateTime()}</h3>
     <p id="response" className='result-text'> 
      {result}
      </p></label>
      
      
      <button type='button' id='save' onClick={saveFile} className='btn text input button'>Save P/R</button> 
      <button className='button text fit input btn no-over'>Continue</button>
      </div> 
      :
       (
  <></>
 )
}


<a className='back-link' href="/">back home</a>

<a href="/openai/m1/select" className='back-link'>Try something else</a>



</div>




    </div>

  );
}

export default OpenAiImage;
